// extracted by mini-css-extract-plugin
export var faqTitle = "faq-module--faqTitle--37ed9";
export var slideUp = "faq-module--slideUp--ab6ce";
export var slideUpLarge = "faq-module--slideUpLarge--25936";